import { useQuery } from '@tanstack/react-query'
import { getOneCourse } from '../api-marketplace'

export const useEcosystemCourse = (slug?: string) => {
    const queryKey = ['Ecosystem', slug, 'Details']
    const queryFn = () => getOneCourse(`${slug}`)

    const { data: course, ...rest } = useQuery({
        queryKey,
        queryFn,
        enabled: !!slug,
    })

    return { course, ...rest }
}
